// Mission info routes send `missionTasks` (labels, in order): the tasks copied
// from the job template, otherwise those of the qualification. Older api
// versions do not send it.
export const getMissionTasks = (infoMission) =>
    (Array.isArray(infoMission?.missionTasks) ? infoMission.missionTasks : [])
        .filter((label) => typeof label === "string")
        .map((label) => label.trim())
        .filter(Boolean);

// Job titles starting with an aspirated h keep "du" ("du Handballeur"); any
// other h is treated as mute ("de l'Hôte de caisse").
// Same rule and list in company, app, app.admin and app-mobile-interim.
const ASPIRATED_H_PREFIXES = ["hach", "haie", "hall", "hand", "hang", "hard", "harn", "hau", "hock", "homard", "hors", "hou", "hub", "huit", "hurl"];

const startsWithVowelSound = (title) => {
    const word = title
        .trim()
        .toLowerCase()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "");
    if (/^[aeiouœæ]/.test(word)) return true;
    if (!word.startsWith("h")) return false;
    return !ASPIRATED_H_PREFIXES.some((prefix) => word.startsWith(prefix));
};

// One pass, so a title containing "$&" or "{title}" is shown as typed.
const fillTitle = (template, title) =>
    template.replace(/\{title\}/g, () => title);

/** "Tâches du Cariste H/F" · "Tâches de l'Agent de quai H/F". */
export const formatMissionTasksTitle = (title, language) => {
    const cleanTitle = typeof title === "string" ? title.trim() : "";
    const template = startsWithVowelSound(cleanTitle)
        ? language.getValue("missionFiche.tasksTitleElided", "Tâches de l'{title}")
        : language.getValue("missionFiche.tasksTitle", "Tâches du {title}");
    return fillTitle(template, cleanTitle);
};
